import { apiClient } from './client';
import type { Dealer, CreateDealerRequest, UpdateDealerRequest, DealerFirm, DealerStats } from '../types';

export const dealersApi = {
  getAll: async (): Promise<Dealer[]> => {
    const response = await apiClient.get<Dealer[]>('/api/dealers');
    return response.data;
  },

  getById: async (id: number): Promise<Dealer> => {
    const response = await apiClient.get<Dealer>(`/api/dealers/${id}`);
    return response.data;
  },

  getFirms: async (id: number): Promise<DealerFirm[]> => {
    const response = await apiClient.get<DealerFirm[]>(`/api/dealers/${id}/firms`);
    return response.data;
  },

  getStats: async (id: number): Promise<DealerStats> => {
    const response = await apiClient.get<DealerStats>(`/api/dealers/${id}/stats`);
    return response.data;
  },

  create: async (data: CreateDealerRequest): Promise<Dealer> => {
    const response = await apiClient.post<Dealer>('/api/dealers', data);
    return response.data;
  },

  update: async (id: number, data: UpdateDealerRequest): Promise<Dealer> => {
    const response = await apiClient.put<Dealer>(`/api/dealers/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/dealers/${id}`);
  },
};
